module.exports = __webpack_public_path__ + "images/common/estimate_free_f31198bbdad983066857e0d4dbb41582.svg";